import {
  changeToClosestPortalLang,
  missingKeyHandler,
} from "common/utils/i18n";
import {
  DEFAULT_LANG,
  type LanguageMap,
  NAMESPACE,
} from "common/i18nConstants";
import { initReactI18next } from "react-i18next";
import { isDevelopment, isJestTest } from "./utils/environment";
import bsLatnBA from "localization-cloud/translations/bs-Latn-BA.json";
import daDK from "localization-cloud/translations/da-DK.json";
import deDE from "localization-cloud/translations/de-DE.json";
import enUS from "localization-cloud/translations/en-US.json";
import esES from "localization-cloud/translations/es-ES.json";
import frFR from "localization-cloud/translations/fr-FR.json";
import i18n, { type ResourceLanguage } from "i18next";
import itIT from "localization-cloud/translations/it-IT.json";
import LanguageDetector from "i18next-browser-languagedetector";
import ltLT from "localization-cloud/translations/lt-LT.json";
import nlNL from "localization-cloud/translations/nl-NL.json";
import plPL from "localization-cloud/translations/pl-PL.json";
import roRO from "localization-cloud/translations/ro-RO.json";
import srRS from "localization-cloud/translations/sr-RS.json";
import svSE from "localization-cloud/translations/sv-SE.json";
import ukUA from "localization-cloud/translations/uk-UA.json";

// types to use for getDataByLanguage which doesn't have correct types
export interface TranslationRoot {
  translations: Record<string, TranslationData>;
}
type TranslationData = string | { [key: string]: TranslationData };

export const getFromTranslationData = (
  path: string,
  data: TranslationRoot
): TranslationData | undefined => {
  const parts = path.split(".");
  let current: TranslationData = data.translations;
  for (const part of parts) {
    if (!current || typeof current === "string") {
      return;
    }
    const currentPart: TranslationData | undefined = current[part];
    if (!currentPart) {
      return;
    }
    current = currentPart;
  }
  return current;
};

export const RESOURCES: LanguageMap<ResourceLanguage> = {
  "bs-Latn-BA": { [NAMESPACE]: bsLatnBA },
  "da-DK": { [NAMESPACE]: daDK },
  "de-DE": { [NAMESPACE]: deDE },
  "en-US": { [NAMESPACE]: enUS },
  "es-ES": { [NAMESPACE]: esES },
  "fr-FR": { [NAMESPACE]: frFR },
  "it-IT": { [NAMESPACE]: itIT },
  "lt-LT": { [NAMESPACE]: ltLT },
  "nl-NL": { [NAMESPACE]: nlNL },
  "pl-PL": { [NAMESPACE]: plPL },
  "ro-RO": { [NAMESPACE]: roRO },
  "sr-Latn-RS": { [NAMESPACE]: srRS },
  "sv-SE": { [NAMESPACE]: svSE },
  "uk-UA": { [NAMESPACE]: ukUA },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .on("languageChanged", (lng) => changeToClosestPortalLang(i18n, lng));

i18n.init({
  missingKeyHandler,
  ns: NAMESPACE,
  resources: RESOURCES,
  fallbackLng: DEFAULT_LANG,
  debug: isDevelopment && !isJestTest,
  returnEmptyString: false,
  returnNull: true,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export { default } from "i18next";
